import React,{useState,useEffect,useRef} from 'react';
import {connect} from 'react-redux';

import {currentRouteSet} from '../../actions/actions';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid'; 
import {BrowserRouter as Router,Route,Link} from 'react-router-dom'
import {pathSpliter,_p,sleep,dateTimeFormat,dateFormat,currentDateTime,getDateTimeFromISODT,currentDateStartTime,currentDateEndTime} from '../../lib/functions'
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import axios from 'axios';
import Button from '@material-ui/core/Button';
import EditIcon from '@material-ui/icons/Edit';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import DdatateIcon from '@material-ui/icons/Delete';
import ReceiptIcon from '@material-ui/icons/Receipt';
import DateFnsUtils from '@date-io/date-fns'; // choose your libs
import {API_URL} from '../../config.json';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import SearchIcon from '@material-ui/icons/Search';
import CircularProgress from '@material-ui/core/CircularProgress';
import moment from 'moment';
import _ from 'lodash';
import ReactToPrint from "react-to-print";
import PrintIcon from '@material-ui/icons/Print';
import InstitutionProfile from '../commons/institution_profile'
import '../commons/commons.css'
import TextareaAutosize from '@material-ui/core/TextareaAutosize';

import { Modal } from 'react-responsive-modal';
import "react-responsive-modal/styles.css";
import Stack from '@mui/material/Stack';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import DesktopDatePicker from '@mui/lab/DesktopDatePicker';


import swal from 'sweetalert';
import commaNumber from 'comma-number';
import { TableFooter } from 'semantic-ui-react';
let format = commaNumber.bindWith(',', '.')
const SalesRecord = ({location,currentRoute,currentRouteSet,authInfo})=>{
    const classes = useStyles();
    useEffect(()=>{
        currentRouteSet(pathSpliter(location.pathname,1));
        getLocations()
        getUsers()
    },[]);

    let [types,typesSet] = useState([{type:'All'},{type:'User Wise'},{type:'Location Wise'},{type:'Customer Wise'}]);
    let [report,reportSet] = useState([]);
    let [selectedType,selectedTypeSet] = useState({type:'All'});
    let [accounts,accountsSet] = useState([]);
    let [locations,locationsSet] = useState([]);
    let [users,usersSet] = useState([]);
    
    let [reportLoading,reportLoadingSet] = useState(false);
    

    let [selectedAccount,selectedAccountSet] = useState(null)
    let [selectedLocation,selectedLocationSet] = useState(null)
    let [selectedUser,selectedUserSet] = useState(null)
  

    let [EntryModal,EntryModalSet] = useState(false)
    let [ViewModal,ViewModalSet] = useState(false)

    let [customer_name,customer_name_set] = useState('')
    let [customer_id,customer_id_set] = useState('')
    let [text,text_set] = useState('')
    let [conversations,conversations_set] = useState([])

    
    
    

    let [print,printSet] = useState(false);
    let [saveing,saveingSet] = useState(false);
    let [loadingAccounts,loadingAccountsSet] = useState(false);
    let [account_name,account_name_set] = useState('');

    let [balanceTotal,balanceTotalSet] = useState(0)


    let AddConv = (customer)=>{
        EntryModalSet(true)
        customer_name_set(customer.acc_name)

        customer_id_set(customer.acc_id)
        console.log(customer)
    }


    let ViewConv = async (customer)=>{
        conversations_set([])
        ViewModalSet(true)
        customer_name_set(customer.acc_name)

        customer_id_set(customer.acc_id)
        console.log(customer)


        let para = {
            customer_id : customer.acc_id
        }
        let url =  `${API_URL}/api/get-conversations`;

        await axios.post(`${url}`,{...para},{headers:{'auth-token':authInfo.token}}).then(res=>{
         conversations_set(res.data)
       })





    }
    
   
    useEffect(()=>{
        selectedAccountSet(null)
        selectedLocationSet(null)
        selectedUserSet(null)
    },[selectedType])



    useEffect(()=>{
          loadingAccountsSet(true)
          axios.post(`${API_URL}/api/get-accounts-by-search`,{query:account_name.trim(),type:'debitor'},{headers:{'auth-token':authInfo.token}}).then(res=>{
            accountsSet(res.data)
            loadingAccountsSet(false)
          })
          
    },[account_name])


    


    const getLocations = async ()=>{
      await axios.post(`${API_URL}/api/get-locations`,null,{headers:{'auth-token':authInfo.token}}).then(res=>{
        locationsSet(res.data)
    })
    }

 

    const getUsers = async ()=>{
        await axios.post(`${API_URL}/api/get-users`,null,{headers:{'auth-token':authInfo.token}}).then(res=>{
          usersSet(res.data.message)
      })
      }


      const action = async (customer,status)=>{

        swal({
            title:`Are you sure " ${customer.acc_name}" ${status =='p' ?'Pending' :'Reject'} this?`,
            icon:'warning',
            buttons:true
         }).then((async res=>{
            if(res){


                let para = {
                    customerId: customer.acc_id,
                    status
                }
         
        
        
                let url =  `${API_URL}/api/customer-status-change`;
        
                await axios.post(`${url}`,{...para},{headers:{'auth-token':authInfo.token}}).then(res=>{
                    getSearchResult()

                    swal({
                        title:"Success",
                        icon:'success'
                     })
        
               })



            }
         }))


        
      }


    
    let getSearchResult = async ()=>{

      if(selectedType == null){
        swal({
          title:'Select Filter Type',
          icon:'warning'
        })
        return false
      }
     
        let url =  `${API_URL}/api/get-approved-customer-list`;

         
            
        let reqPayload = {
            locationId: selectedLocation != null? selectedLocation.location_id:null,
            customerId: selectedAccount != null? selectedAccount.acc_id:null,
            userId: selectedUser != null? selectedUser.user_id:null,
        }

        
        reportLoadingSet(true)
        await axios.post(`${url}`,{...reqPayload},{headers:{'auth-token':authInfo.token}}).then(res=>{
             printSet(true)
             reportLoadingSet(false)
            reportSet(res.data)
            balanceTotalSet(res.data.total_balance)
        })



    }



    let saveConv = async ()=>{


        if(text.trim() == ''){
            swal({
                title:`Conversation Required !`,
                icon:'warning'
              })
              return false
        }

        let para = {
            text,
            customer_id
        }
        saveingSet(true)
        let url =  `${API_URL}/api/save-conversation`;

        await axios.post(`${url}`,{...para},{headers:{'auth-token':authInfo.token}}).then(res=>{
            saveingSet(false)

           text_set('');
           EntryModalSet(false)
       })


    }



    let ReportDom = React.forwardRef( (props,ref) =>{
        return(
          <div ref={ref} >
                        <InstitutionProfile />

<div style={{clear:'both'}}></div>
<Paper style={{paddingLeft:'10px',paddingRight:'10px'}} className="print-source">
<p style={{width:'100%',textAlign:'center',fontWeight:'bold'}}>   Approved Customer List</p>
<div style={{float:'left',width:'50%',textAlign:'left',margin:0,padding:0,fontSize:'16px'}}>

</div>

<div style={{width:'10%'}}></div>

<div style={{float:'right',width:'40%',textAlign:'left',margin:0,padding:0,fontSize:'16px'}}>

</div>
 


</Paper> 

{
    report.length > 0 ?(<>
    <Paper className={classes.paper}  style={{paddingLeft:'10px',paddingRight:'10px',marginTop:'1px',marginBottom:'1px'}}>
    
    {/* sale Record  without item */} 
    <TableContainer >
      <Table className={classes.table} size="small" aria-label="a dense table" className="report-dom">
        <TableHead>
          <TableRow> 
            <TableCell align="left"  width="3%">SL</TableCell>
            <TableCell align="left"  width="15%">Customer Name </TableCell>
            <TableCell align="left"  width="10%">Contact No</TableCell>
            <TableCell align="left"  width="10%">Profession  </TableCell>
            <TableCell align="left"  width="15%">Address</TableCell>
            <TableCell align="left"  width="15%">Area</TableCell>
            <TableCell align="left"  width="5%">Expectation %</TableCell>
            <TableCell align="left"  width="15%">E-mail Address </TableCell>
            <TableCell align="left"  width="15%">Date </TableCell>
            <TableCell align="right"  width="15%" className="print-no">Conversation Add/ View </TableCell>
            <TableCell align="right"  width="5%" className="print-no">Approve </TableCell>
            <TableCell align="right"  width="5%" className="print-no">Reject </TableCell>
    
          </TableRow>
        </TableHead>
        <TableBody>
                {
                    report.map((acc,ind)=>(
                        <TableRow  key={ind}> 
                        <TableCell  align="left" >{ind+parseFloat(1)}</TableCell>
                        <TableCell  align="left">{acc.acc_name}</TableCell>
                        <TableCell  align="left">{acc.contact_no}</TableCell>
                        <TableCell  align="left">{acc.profession}</TableCell>
                        <TableCell  align="left">{acc.address}</TableCell>
                        <TableCell  align="left">{acc.location_name}</TableCell>
                        <TableCell  align="left">{acc.expectation_per}</TableCell>
                        <TableCell  align="left">{acc.email_address}</TableCell>
                        <TableCell  align="left">{moment(acc.creation_date).format(dateFormat)}</TableCell>
                        <TableCell  align="right" className="print-no">
                            <button style={{cursor:'pointer',background:'green',color:'white',}} onClick={
                               ()=>{
                                AddConv(acc)
                               }
                            }>Add  </button>

<button style={{cursor:'pointer',background:'green',color:'white'}} onClick={
                               ()=>{
                                ViewConv(acc)
                               }
                            }>View  </button>


                        </TableCell>


                        <TableCell  align="right" className="print-no">
                            <button style={{cursor:'pointer',background:'green',color:'white',margin:'5px'}} onClick={
                               ()=>{
                                action(acc,'p')
                               }
                            }>Pending</button>



                        </TableCell>

                        <TableCell  align="right" className="print-no">
                           

<button style={{cursor:'pointer',background:'red',color:'white',margin:'5px'}} onClick={
                               ()=>{
                                action(acc,'r')
                               }
                            }>Reject</button>


                        </TableCell>

                   
                       </TableRow>
                    ))
                }

              


        </TableBody>


 
       
      </Table>
    </TableContainer>
        </Paper>
  
    </>):''
    
}
    


      
     
<div style={{clear: 'both',height:'10px'}}></div>
<div  className="print-source" style={{marginTop:'70px'}}>
                                <p style={{float:'left',borderTop:'1px solid #222',width:'150px',textAlign:'center'}}>Received By</p>
                           
                                 <p style={{float:'right',marginRight:'10px',borderTop:'1px solid #222',width:'150px',textAlign:'center'}}>Authorized By</p>
                      </div>
          </div>
        )
    })




    const reportRef = useRef();

   

      return(
          <div className={classes.root}> 
<Paper className={classes.paper} style={{marginTop:'-25px',marginBottom:'5px'}}>
<h4 style={{ textAlign: 'left',margin: "0px 0px  7px 0px",padding: '0px',color: '#222'}}>   Approved Customer List</h4>
<Grid container spacing={3} > 
          <Grid item  xs={12}  sm={2}> 
          <Autocomplete 
          size="small"
          autoHighlight
              openOnFocus={true}
              style={{width:'100%',height:'20px'}}
              options={types} 
              value={selectedType}
              getOptionLabel={(option) => option.type}
              onChange={(event,selectedObj)=>{
                selectedTypeSet(selectedObj) 
              }}
              renderInput={(params) => <TextField 
               
                {...params} 
                label="Filter Type" 
                variant="outlined"
                />} 
          />

          </Grid>

          
         


          <Grid item  xs={12}   sm={3} style={{display: selectedType!=null && (selectedType.type =='Customer Wise' )?'block':'none'}}> 
          <Autocomplete 
           autoHighlight
           size="small"
             openOnFocus={true}
             style={{width:'100%',height:'20px'}}
             options={accounts}
             loading={loadingAccounts}
             value={selectedAccount}
             getOptionLabel={(option) => option.display_text}
             onChange={(event,selectedObj)=>{
                selectedAccountSet(selectedObj) 
             }}
             renderInput={(params) => <TextField 
              label="Select Customer " 
               onChange={e => account_name_set(e.target.value)} 
               {...params} 
               InputProps={{
                ...params.InputProps,
                endAdornment: (
                  <React.Fragment>
                    {loadingAccounts ? <CircularProgress color="inherit" size={20} /> : null}
                    {params.InputProps.endAdornment}
                  </React.Fragment>
                ),
              }}
               variant="outlined"
               />} 
          
      />
          </Grid>


          <Grid item  xs={12}   sm={3} style={{display: selectedType!=null && (selectedType.type=='User Wise')?'block':'none'}}> 
          <Autocomplete 
          size="small"
          autoHighlight
              openOnFocus={true}
              style={{width:'100%',height:'20px'}} 
              options={users}
              value={selectedUser}
              getOptionLabel={(option) => option.user_full_name}
              onChange={(event,selectedObj)=>{
                 selectedUserSet(selectedObj);
              }}
              renderInput={(params) => <TextField                
                {...params} 
                label="Select User" 
                variant="outlined"
                />} 
                
          />
          </Grid>




          <Grid item  xs={12}   sm={3} style={{display: selectedType!=null && (selectedType.type=='Location Wise')?'block':'none'}}> 
          <Autocomplete 
          size="small"
          autoHighlight
              openOnFocus={true}
              style={{width:'100%',height:'20px'}} 
              options={locations}
              value={selectedLocation}
              getOptionLabel={(option) => option.location_name}
              onChange={(event,selectedObj)=>{
                 selectedLocationSet(selectedObj);
              }}
              renderInput={(params) => <TextField                
                {...params} 
                label="Select Location" 
                variant="outlined"
                />} 
                
          />
          </Grid>

          <Grid item  xs={12}   sm={2} >
        <Button style={{marginTop: '5px',marginLeft: 'auto',fontSize:'10px'}} 
                            variant="contained"
                            color="primary"
                            className={classes.button}
                            startIcon={<SearchIcon/>}
                            onClick={getSearchResult}
                            disabled={reportLoading?true:false}
                        >
                        GET List 
                      </Button>
        </Grid>
        


          </Grid>


        </Paper>
        {
          print?(
            <Grid container >
            <Grid item xs={12} sm={12} >
              <Paper style={{borderRadius:'0px',marginTop: '-17px'}}>
              <ReactToPrint
                          trigger={() => <PrintIcon  style={{cursor:'pointer',marginLeft: '30px',marginTop: '3px',marginBottom: '-8px'}} />}
                          content={() => reportRef.current}
                        />
              </Paper>
           
            </Grid>
        </Grid>
          ):''
        }
      
            <ReportDom ref={reportRef} /> 






            <Modal
        open={EntryModal}
        onClose={() => EntryModalSet(false)}
        center
        style={{minWidth:'600px !important',minHeight:'500px'}}
 
      
      >
        <h2 style={{margin: 0,
    padding: 0,
    color: '#0f7e77'}}> Last conversation Entry <br/> of  <span style={{color:'red'}}>{customer_name} </span></h2>
     

        <br/>
       

        <Grid container spacing={2}>
      
      <Grid item xs={12} sm={12}> 
      <TextareaAutosize 
            
               onChange={(e)=>{text_set(e.target.value)}} value={text}  name="conversation" style={{float:'left',width: '100%'}} aria-label="Conversation..." rowsMin={6} placeholder="Conversation..." />
      </Grid>


    


<Grid item xs={12} sm={12}> 
      

<button style={{cursor:'pointer',background:'green',color:'white',padding: '14px'}} disabled={saveing} onClick={
                               ()=>{
                                saveConv()
                               }
                            }>Save </button>


      </Grid>



      </Grid>


  

      </Modal>





      <Modal
        open={ViewModal}
        onClose={() => ViewModalSet(false)}
        center
        style={{minWidth:'600px !important',minHeight:'500px'}}
 
      
      >
        <h2 style={{margin: 0,
    padding: 0,
    color: '#0f7e77'}}>  Conversation History <br/> of  <span style={{color:'red'}}>{customer_name} </span></h2>
     

        <br/>
       

        <Grid container spacing={2}>


      
      <Grid item xs={12} sm={12}> 



<TableContainer >
      <Table className={classes.table} size="small" aria-label="a dense table">
        <TableHead>
          <TableRow>
            <TableCell align="left">SL</TableCell>
            <TableCell align="left">Conversation</TableCell>
            <TableCell align="right">Date</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>

        
        
        {
            conversations.map((conv,ind)=>(
              <TableRow style={{margin:'5px'}}>
              <TableCell align="left" style={{fontWeight:'bold'}}>{ind+parseFloat(1)}</TableCell>
              <TableCell align="left" style={{whiteSpace:'pre-line'}}>{conv.conversation}</TableCell>
              <TableCell align="right" style={{fontWeight:'bold'}}>{moment(conv.created_date).format(dateFormat)}</TableCell>
            </TableRow>
            ))
          }

     
        



        </TableBody>
      </Table>
    </TableContainer>




      </Grid>


      </Grid>


  

      </Modal>



          </div>
      )
}



const useStyles = makeStyles((theme) => ({
    button: {
        margin: theme.spacing(1),
        color: 'white',
        fontSize:'10px',
        backgroundColor: '#115f5f'
      },
    
    root: {
      flexGrow: 1,
    },
    inputField:{
      width:'100%',
      marginTop:'5px'
    },
    plusLinkDiv:{
      position:'relative'  
    },
    plusLink:{
      margin: 0,
      padding: 0,
      marginTop: '-21px',
      fontSize: '29px',
      height: '21px',
      textAlign: 'right',
      position: 'absolute',
      right: 0,
      color: '#3e8d54'
    },
    paper: {
      padding: theme.spacing(1),
      textAlign: 'center',
      color: theme.palette.text.secondary,
    },
  }));


const mapStateToPops = (state)=>{
      return {
        currentRoute:state.currentRouteReducer,
        authInfo:state.authInfoReducer
      }
}
export default connect(mapStateToPops,{currentRouteSet})(SalesRecord); 
